import React from "react";
import loadable from "@loadable/component";
import CenterSpinner from "../../common/centerSpinner";

function AsyncSupportParishListing({ ...rest }) {
  const AsyncLoad = loadable(() => import("../supportParishListingPage"));
  console.log("Loading", AsyncSupportParishListing.name);
  return <AsyncLoad {...rest} fallback={<CenterSpinner />} />;
}

export default AsyncSupportParishListing;
